import { TabsProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: TabsProps = {
  items: [
    { id: 1, title: 'item 1' },
    { id: 2, title: 'item 2' },
  ],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as TabsProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
